import React from "react";
import styled, {css} from "styled-components";
import {Tab} from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";

export const TabsWrapper = styled(Tab)`
    ${props => props.disabled && css`
        pointer-events: all !important;
        cursor: not-allowed !important;
        &:hover {
            color: #b93535 !important
        }`
    }
    ${props => props?.isInvalid &&  css`
        color: #e60606 !important
    `}
`;

export const PDFWrapper = styled(AccordionDetails)`
    display: inline-flex;
    font-size: 1rem;
    cursor: pointer;
    justify-content: center;
    border: 0.5px solid #ffc4c4;
    &:hover {
      background: #e6f0ff !important
    }
`;